import * as React from "react";
const SvgFiRrHelmetBattle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-helmet-battle_svg__a)">
      <path
        fill="#062147"
        d="M14.144.638a3.93 3.93 0 0 0-4.287 0C6.923 2.548 2.001 6.36 2.001 10.42v6.344c0 2.13 1.272 4.03 3.242 4.841l4.972 2.047a4.69 4.69 0 0 0 3.572 0l4.972-2.047a5.22 5.22 0 0 0 3.242-4.84V10.42c0-4.06-4.923-7.872-7.856-9.782zM12 15.061l-3.703-1.998A.566.566 0 0 1 8.565 12h6.869a.566.566 0 0 1 .268 1.064zm8 1.702c0 1.316-.786 2.49-2.004 2.991l-4.972 2.047-.024.007v-5.014l3.652-1.972A2.56 2.56 0 0 0 18 12.564a2.57 2.57 0 0 0-2.565-2.566H8.566a2.57 2.57 0 0 0-2.565 2.566c0 .944.517 1.81 1.348 2.258l3.652 1.972v5.014l-.024-.007-4.972-2.047a3.22 3.22 0 0 1-2.004-2.99v-6.345c0-3.233 4.859-6.746 6.948-8.106a1.93 1.93 0 0 1 2.104 0c2.089 1.36 6.948 4.873 6.948 8.106z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-helmet-battle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHelmetBattle;
